<template>
    <div>
        <template v-if="geoCenter && infoWindowsList.length > 0">
            <google-map id="map" ref="Map" :zoom="10" :center="geoCenter">
                <google-map-marker
                :key="index"
                v-for="(infoWindow, index) in infoWindowsList"
                :position="infoWindow.position"
                :icon="'/assets/web/images/marker_' + infoWindow.marker + '.png'"
                :clickable="true"
                @click="toggleInfoWindow(infoWindow)"
            />
            <google-map-infowindow id="info-window"
                :position="infoWindowContext.position"
                :show.sync="showInfo"
                :options="{maxWidth: 300}"
                @info-window-clicked="infoClicked"
            >
                <div>
                    <div class="map-info-window" v-html="infoWindowContext.description"></div>
                </div>
            </google-map-infowindow>
            </google-map>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            geoCenter: false,
            showInfo: false,
            infoWindowContext: {
                description: '',
                position: {
                    lat: 0,
                    lng: 0
                }
            },
            infoWindowsList: [],
        }
    },
    computed:{
        filter: {
            get(){
                return this.$root.filter;
            }
        },
        properties: {
            get(){
                return this.$root.properties;
            }
        }
    },
    watch:{
        'properties': function(){
            this.infoWindowsList = [];
            let locations = [];
            for(var index in this.properties){
                if(this.properties[index].location != '' && this.properties[index].location != null){
                    this.infoWindowsList.push({
                        description: `<a href="${this.property_route.replace('slug', this.properties[index].translate.slug)}${`?when_start=${this.filter.when_start}&when_end=${this.filter.when_end}&booking_type=${this.filter.booking_type}&how_long=${this.filter.how_long}`}" target="_blank">
                            <img src="/storage/${this.properties[index].images[0].path}">
                            <h4>${this.properties[index].translate.name}</h4>
                            <div class="address">${this.properties[index].public_address}</div>
                            <div class="phone">${this.properties[index].phone}</div>
                            <div class="price"><span>${this.number_format(this.properties[index].price)}</span> Ft ${this.__('pages.property.prices.from')}</div>
                            </a>
                        `,
                        position: this.properties[index].location,
                        marker: this.properties[index].base_category
                    });

                    locations.push([this.properties[index].location.lat, this.properties[index].location.lng]);
                }
            }

            this.getLatLngCenter(locations);
        }
    },
    props:['property_route'],
    methods: {
        toggleInfoWindow(context) {
            this.infoWindowContext = context
            this.showInfo = true
        },
        infoClicked(context) {
            
        },

        rad2degr(rad) { return rad * 180 / Math.PI; },
        degr2rad(degr) { return degr * Math.PI / 180; },

        getLatLngCenter(latLngInDegr) {
            var LATIDX = 0;
            var LNGIDX = 1;
            var sumX = 0;
            var sumY = 0;
            var sumZ = 0;

            for (var i=0; i<latLngInDegr.length; i++) {
                var lat = this.degr2rad(latLngInDegr[i][LATIDX]);
                var lng = this.degr2rad(latLngInDegr[i][LNGIDX]);
                // sum of cartesian coordinates
                sumX += Math.cos(lat) * Math.cos(lng);
                sumY += Math.cos(lat) * Math.sin(lng);
                sumZ += Math.sin(lat);
            }

            var avgX = sumX / latLngInDegr.length;
            var avgY = sumY / latLngInDegr.length;
            var avgZ = sumZ / latLngInDegr.length;

            // convert average x, y, z coordinate to latitude and longtitude
            var lng = Math.atan2(avgY, avgX);
            var hyp = Math.sqrt(avgX * avgX + avgY * avgY);
            var lat = Math.atan2(avgZ, hyp);

            this.geoCenter = {lat: this.rad2degr(lat), lng: this.rad2degr(lng)};
        }
    }
}
</script>